import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

export const Nav = () => (
    <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
            <button
                data-testid="nav-brand"
                onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
                className="font-serif tracking-[0.25em] text-sm sm:text-base uppercase text-white hover:text-gold transition-colors duration-300"
            >
                Toriano Sanzone
            </button>
            <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] tracking-[0.3em] uppercase text-zinc-400">
                <button data-testid="nav-link-what-you-get" onClick={() => scrollToId("what-you-get")} className="hover:text-gold transition-colors duration-300">The Offer</button>
                <button data-testid="nav-link-manifesto" onClick={() => scrollToId("manifesto")} className="hover:text-gold transition-colors duration-300">Manifesto</button>
            </nav>
            <button
                data-testid="nav-cta-button"
                onClick={() => scrollToId("checkout")}
                className="gold-border-beam bg-gold/10 text-gold font-mono text-[11px] tracking-[0.2em] uppercase px-4 py-2 hover:bg-gold hover:text-black transition-colors duration-300"
            >
                Get Access<span className="hidden sm:inline"> — $19.99</span>
            </button>
        </div>
    </motion.header>
);
